import Styled from '@/components/GlowQuote/GlowQuote.styled';
import { VisuallyHidden } from '@/components/Helpers';
import Image from '@/components/Image';
import { Container } from '@/components/layout/Container';
import { parseHtml } from '@/lib/parse-html';
import { FC } from 'react';

interface GlowQuoteProps extends PropsWithClassName {
  quote: string;
  authorName: string;
  authorTitle?: string;
  authorImage?: {
    src: string;
    width: number;
    height: number;
  };
  companyName?: string;
  logo?: {
    src: string;
    width: number;
    height: number;
    isTaller: boolean;
  };
}

const GlowQuote: FC<GlowQuoteProps> = (props) => {
  return (
    <Styled.Section className={props.className}>
      <Container>
        <Styled.Quote hasImage={!!props.authorImage}>
          {parseHtml(props.quote)}

          <footer>
            {props.authorImage && (
              <Styled.AuthorImage>
                <Image
                  src={props.authorImage.src}
                  width={props.authorImage.width}
                  height={props.authorImage.height}
                  sizes="115px"
                  alt=""
                />
              </Styled.AuthorImage>
            )}

            <div>
              <Styled.AuthorNameTitle>
                <span>
                  <strong>{props.authorName ?? ''}</strong>
                </span>

                {props.authorTitle && (
                  <>
                    <VisuallyHidden>, </VisuallyHidden>
                    <span>{props.authorTitle ?? ''}</span>
                  </>
                )}

                {props.logo ? (
                  <Styled.Logo
                    src={props.logo.src}
                    width={props.logo.width}
                    height={props.logo.height}
                    alt={`${props.companyName} logo`}
                    taller={props.logo.isTaller}
                  />
                ) : props.companyName ? (
                  <Styled.AuthorCompanyName>{props.companyName}</Styled.AuthorCompanyName>
                ) : null}
              </Styled.AuthorNameTitle>
            </div>
          </footer>
        </Styled.Quote>
      </Container>
    </Styled.Section>
  );
};

export default GlowQuote;
